import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";

export default function CalendlyFloatingButton() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const existing = document.querySelector("#calendly-js");
    if (!existing) {
      const script = document.createElement("script");
      script.id = "calendly-js";
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    window.openCalendly = () => setOpen(true);
  }, []);

  const toggle = () => setOpen(!open);

  return (
    <>
      <button
        onClick={toggle}
        className="fixed bottom-6 right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white px-5 py-4 rounded-full shadow-xl flex items-center gap-2 transition"
      >
        <FontAwesomeIcon icon={faCalendarCheck} className="text-xl" />
        <span className="hidden sm:block font-medium">Book Call</span>
      </button>

      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold">Schedule a Call</h2>
          <button onClick={toggle} className="text-xl font-bold">×</button>
        </div>

        <div className="p-0">
          <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/lloca-aiagenciesdirectory/30min"
            style={{ minWidth: "100%", height: "700px" }}
          ></div>
        </div>
      </div>
    </>
  );
}
